"use client";
import * as React from "react";
const SvgLogoutRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11.775 3.66c-.31.3-.31.79 0 1.09l1.521 1.48H5.933c-.44 0-.8.35-.8.78 0 .43.36.78.8.78h7.363l-1.52 1.48c-.31.3-.31.79 0 1.09.31.3.81.3 1.12 0l2.871-2.79c.31-.3.31-.79 0-1.1l-2.871-2.8a.81.81 0 0 0-1.12 0v-.01ZM1.601 1.56h5.602c.44 0 .8-.35.8-.78 0-.43-.36-.78-.8-.78H1.601C.72 0 0 .7 0 1.56v10.88C0 13.3.72 14 1.6 14h5.603c.44 0 .8-.35.8-.78 0-.43-.36-.78-.8-.78H1.601V1.56Z" }));
export {
  SvgLogoutRound as default
};
